import {createGtm} from '@gtm-support/vue-gtm'

//not working need special treatment
export default defineNuxtPlugin({
  name: 'gtm',
  async setup(nuxtApp) {
    const runtimeConfig = useRuntimeConfig()
    const router = useRouter()
    const regions = runtimeConfig.public.regions || []
    window.dataLayer = window.dataLayer || []

    // Extract region from URL path (e.g., /eu/en/..., /na/de/...), ignoring non-region
    // segments such as /auth, /orderHistory or widget-only routes that have no region prefix
    const extractRegion = () => {
      const firstSegment = window.location.pathname.split('/').filter(Boolean)[0] || ''
      const validRegion = regions.find(region => region.RegionShortName.toLowerCase() === firstSegment.toLowerCase())
      return validRegion ? validRegion.RegionShortName : ''
    }

    nuxtApp.vueApp.use(
      createGtm({
        enabled: false,
        id: runtimeConfig.public.GTM_ID || 'GTM-MF4HR32',
        defer: true,
        compatibility: true,
        nonce: '2726c7f26c',
        debug: true,
        loadScript: true,
        source: 'https://sst.fst.com/gtm.js',
        vueRouter: router,
        vueRouterAdditionalEventData: () => ({
          region: extractRegion()
        })
      })
    )
    nuxtApp.vueApp.__gtm__installed = true

    nuxtApp.provide('gtmReset', () => {
      window.dataLayer?.push(function() {
        this.reset()
      })
    })

    nuxtApp.provide('gtmNewSession', () => {
      let hostname = window.location.hostname
      try {
        hostname = new URL(runtimeConfig.public.BASE_URL).hostname || hostname
      } catch {
        // fall back to the current window hostname
      }
      const parts = hostname.split('.')
      const domains = new Set([hostname, `.${hostname}`, ''])
      for (let i = 0; i < parts.length - 1; i++) {
        domains.add(`.${parts.slice(i).join('.')}`)
      }
      document.cookie.split('; ').forEach((entry) => {
        const name = entry.split('=')[0]
        if (!name.startsWith('_ga_') && name !== 'FPLC') { return }
        domains.forEach((domain) => {
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain ? `; domain=${domain}` : ''}`
        })
      })
    })
  }
})
